export const THEME_STORAGE_KEY = "theme";

export function getInitialTheme() {
  let saved;
  try { saved = window.localStorage.getItem(THEME_STORAGE_KEY); } catch { /* Storage can be unavailable in private browsing. */ }
  if (saved === "light" || saved === "dark") {
    return saved;
  }
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function applyThemeAttribute(theme) {
  const mode = theme === "dark" ? "dark" : "light";
  document.documentElement.setAttribute("data-theme", mode);
  document.documentElement.setAttribute("data-bs-theme", mode);
}
